;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLeftArrowRoundedCorners = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 34,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 3.07,
  x: 0.055,
  y: 16.836,
  fill: "#092C3C",
  rx: 1.535,
  transform: "rotate(-44.546 .055 16.836)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 3.07,
  x: 2.159,
  y: 14.848,
  fill: "#092C3C",
  rx: 1.535,
  transform: "rotate(44.69 2.16 14.848)"
})));
export default SvgLeftArrowRoundedCorners;